/**
 * Internal Demo Center entry point shown only to superusers.
 */

import { Shield } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useLogisticsModeStore } from '@/stores/logisticsModeStore'
import { cn } from '@/lib/utils'

export function LogisticsModeSwitcher() {
  const { activeMode, setMode } = useLogisticsModeStore()
  const navigate = useNavigate()

  return (
    <button
      type="button"
      onClick={() => {
        setMode('admin')
        navigate('/showcase')
      }}
      className={cn(
        'hidden items-center gap-2 rounded-lg border px-3 py-2 text-xs font-bold uppercase tracking-wider transition md:flex',
        activeMode === 'admin'
          ? 'border-slate-400/40 bg-slate-500/10 text-foreground shadow-sm'
          : 'border-border bg-muted/50 text-muted-foreground hover:bg-accent hover:text-foreground'
      )}
      title="Volver al ARAM Demo Center"
    >
      <Shield className="h-4 w-4" />
      Admin
    </button>
  )
}
